<template>
    <b-button v-bind="$attrs" v-on="$listeners" type="submit" :class="['form-button', size ? size : 'default', float ? float : 'right', { disabled: isLoading }]">{{title || 'Salvar'}}</b-button>
</template>

<script>
export default {
    props: ['title', 'size', 'float'],
    computed: {
        isLoading() {
            return this.$store.state.show.loading;
        }
    }
}
</script>

<style scoped>
    .default {
        width: 80px;
    }

    .large {
        width: 100px;
    }

    .auto {
        width: auto;
    }

    .left {
        float: left;
    }

    .right {
        float: right;
    }

    .disabled {
        opacity: 0.6;
        pointer-events: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/shared/FormButton.vue